var _rect, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 268,
    viewBox: "0 0 343 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 268,
    fill: "#082C4E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3166 66.252C100.323 66.252 106.002 60.5991 106.002 53.626C106.002 46.6529 100.323 41 93.3166 41C86.3105 41 80.6309 46.6529 80.6309 53.626C80.6309 60.5991 86.3105 66.252 93.3166 66.252Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.768 68.7482H83.7358C83.0155 68.7326 82.3184 69.0019 81.7973 69.497C81.2761 69.9921 80.9735 70.6726 80.9556 71.3895V79.207C80.9481 79.5627 80.8701 79.9135 80.7263 80.2393C80.5825 80.5651 80.3755 80.8595 80.1174 81.1057C79.8592 81.3519 79.5548 81.545 79.2216 81.6741C78.8884 81.8032 78.5329 81.8656 78.1755 81.8579H60.7557C60.0437 81.8552 59.3591 82.1302 58.8484 82.6239C58.3378 83.1177 58.0419 83.7909 58.0241 84.4992V92.2393C58.0063 92.9561 57.7036 93.6367 57.1825 94.1318C56.6613 94.6269 55.9642 94.8962 55.2439 94.8806H45.2509C44.8926 94.8729 44.5363 94.9357 44.2025 95.0654C43.8687 95.195 43.5639 95.389 43.3056 95.6362C43.0473 95.8834 42.8406 96.179 42.6973 96.5059C42.554 96.8328 42.477 97.1846 42.4707 97.5412V105.359C42.4885 106.078 42.7922 106.761 43.3152 107.258C43.8382 107.755 44.5377 108.025 45.2606 108.01H101.768C102.491 108.025 103.19 107.755 103.713 107.258C104.236 106.761 104.54 106.078 104.558 105.359V71.3895C104.549 71.0337 104.47 70.6831 104.325 70.3578C104.18 70.0325 103.972 69.7388 103.713 69.4935C103.454 69.2482 103.149 69.0561 102.815 68.9282C102.481 68.8004 102.125 68.7392 101.768 68.7482Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9886 99.3608C36.7456 93.1204 40.2062 81.2587 44.6001 78.5884C52.8822 73.5283 55.4777 93.101 50.6367 93.0333C44.6389 93.0333 49.6646 78.898 53.7571 73.0639C63.7793 58.9092 73.3447 64.8304 75.0847 69.9582C76.4262 73.9153 75.3083 80.0009 72.2948 79.9235C68.9411 79.8365 68.3384 74.5829 69.5535 70.5194C71.9546 62.46 79.2064 55.4456 84.0376 52.7849",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2441 62.8372C87.6976 64.7744 90.7782 65.7517 93.9054 65.5849C98.1632 65.4978 100.574 63.9401 103.072 61.5601",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.295 74.8477C290.854 74.8477 298.603 67.0265 298.603 57.3786C298.603 47.7307 290.854 39.9095 281.295 39.9095C271.736 39.9095 263.986 47.7307 263.986 57.3786C263.986 67.0265 271.736 74.8477 281.295 74.8477Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.418 58.3408C276.116 59.7394 277.165 60.9288 278.461 61.7903C279.757 62.6518 281.254 63.1553 282.803 63.2506C284.347 63.2832 285.859 62.8031 287.107 61.8842C288.355 60.9653 289.27 59.6583 289.71 58.1641",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.254 56.7308C289.393 56.5751 290.549 56.8364 291.513 57.4673",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.09 56.4362L273.549 58.7241C274.775 57.9189 275.864 57.2414 277.09 56.4362Z",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.604 54.433C259.117 54.1386 257.696 53.5729 256.41 52.7636C255.768 52.3523 255.217 51.8124 254.79 51.1773C254.363 50.5422 254.07 49.8255 253.929 49.0715C253.819 48.3979 253.935 47.7065 254.26 47.1076C254.98 45.8703 256.614 45.5855 258.045 45.5462C262.601 45.4541 267.107 46.5284 271.14 48.6689C264.194 40.8132 264.807 34.4305 266.14 33.1441C269.126 30.1982 272.434 34.5679 273.203 35.7561C275.045 38.8076 276.432 42.1163 277.319 45.5757C277.883 41.8639 279.099 33.9395 282.436 30.9249C282.923 30.4874 283.518 30.1893 284.158 30.0616C284.797 29.9338 285.459 29.981 286.075 30.1982C287.661 30.7972 288.429 32.6335 288.634 34.3224C289.13 38.4663 287.301 42.4923 285.52 46.2532C288.219 43.5678 291.314 41.3218 294.695 39.5956C299.346 37.3076 300.854 39.5366 301.301 40.4302C303.121 44.1224 295.522 51.0845 293.148 53.1957C296.923 52.5378 307.003 54.5606 305.962 59.1562C305.164 62.6618 295.882 62.5832 292.526 62.6618C295.444 63.8205 301.369 67.6894 300.747 71.2147C300.027 75.3192 292.574 72.4519 286.279 66.5896C287.729 68.5535 291.562 76.7038 287.116 78.8838C285.744 79.5515 283.506 78.3535 281.862 76.1048C280.218 73.8561 279.313 70.6353 278.788 67.7483C277.815 73.2866 272.113 81.8787 267.336 79.5319C262.909 77.3814 268.815 67.4047 270.956 64.1151C268.348 66.9824 260.253 71.4798 257.334 68.8776C254.416 66.2754 258.823 59.3919 264.145 56.6227C264.544 56.4067 266.772 55.0221 266.772 55.0221C266.772 55.0221 261.956 54.7472 260.604 54.433Z",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.836 69.6332C278.836 69.6332 280.169 83.0369 282.027 93.8876",
    stroke: "#F2EAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.973 89.2433C254.919 89.2433 263.733 89.3709 265.689 89.0763C266.594 88.9389 270.048 84.8048 272.587 83.8523C275.126 82.8998 276.479 83.4104 277.753 84.5397C281.859 88.1337 281.081 96.8731 280.429 100.634C280.429 100.811 279.933 103.757 277.938 103.58C275.311 103.315 274.64 94.7422 274.367 92.7783C274.192 97.0793 272.947 102.745 269.824 104.405",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.119 87.5058C283.59 87.2201 287.078 87.2201 290.549 87.5058C296.474 88.2423 297.583 93.8591 293.341 95.3615C290.977 96.206 285.383 96.746 283.242 95.8623C281.296 95.0767 282.123 92.504 284.118 91.8657C288.01 90.6186 289.887 90.8837 289.887 90.8837",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.282 95.4688C293.73 95.531 294.149 95.7259 294.487 96.0287C294.826 96.3315 295.067 96.7287 295.182 97.1701C295.296 97.6115 295.279 98.0773 295.131 98.5085C294.983 98.9398 294.712 99.3171 294.352 99.593C291.881 101.743 287.435 101.714 282.979 101.174",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.524 100.84C295.89 102.902 292.835 105.828 289.79 106.506C287.59 106.903 285.334 106.853 283.154 106.359",
    stroke: "#F2EAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.535 111.456C287.199 111.574 292.793 111.515 292.881 107.98",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.506 111.897C260.008 111.897 265.214 111.426 268.668 112.035C271.83 112.585 277.093 115.472 282.172 113.086",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.203 43.17C160.203 43.17 169.495 39.8461 173.406 38.1013C173.585 38.0202 173.779 37.9764 173.975 37.9725C174.171 37.9685 174.366 38.0046 174.548 38.0784C174.73 38.1522 174.895 38.2623 175.033 38.4019C175.172 38.5416 175.28 38.7079 175.352 38.8909L178.213 45.9577C178.29 46.1403 178.329 46.3366 178.328 46.5347C178.328 46.7329 178.287 46.9289 178.209 47.1109C178.131 47.293 178.017 47.4573 177.874 47.5942C177.73 47.731 177.561 47.8375 177.376 47.9072L164.387 52.8686L160.203 43.17Z",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.02 108C188.395 108 199.237 97.1378 199.237 83.7387C199.237 70.3396 188.395 59.4774 175.02 59.4774C161.645 59.4774 150.803 70.3396 150.803 83.7387C150.803 97.1378 161.645 108 175.02 108Z",
    fill: "#3098F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.447 80.4836C147.049 82.3844 138.069 88.0086 139.042 91.2057C139.927 94.052 148.47 93.7693 152.089 93.2332C160.983 91.9641 169.724 89.7855 178.175 86.7317C186.78 83.7835 195.064 79.9656 202.898 75.337C206.79 72.9684 212.521 68.5138 206.177 67.5391C201.887 67.048 197.547 67.2321 193.314 68.0849",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.213 43.4139C163.132 50.2371 164.883 57.1773 167.763 64.2344",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.575 222.267C128.338 222.267 141.116 209.349 141.116 193.413C141.116 177.478 128.338 164.559 112.575 164.559C96.8131 164.559 84.0352 177.478 84.0352 193.413C84.0352 209.349 96.8131 222.267 112.575 222.267Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3965 238.846C96.0951 234.878 117.925 228.002 116.978 223.548C115.963 218.437 103.17 224.09 97.8068 226.063",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.754 224.853C104.908 219.949 118.134 207.409 116 205.24C113.307 202.528 102.306 214.631 96.7601 218.242C101.165 213.027 113.432 200.475 111.15 198.398C110.112 197.452 108 198.306 105.513 200.025C103.536 201.433 101.657 202.974 99.8869 204.64C96.8912 207.418 94.0565 210.369 91.3967 213.477C95.2538 208.943 103.733 197.648 101.815 195.999C99.0196 193.61 92.1498 203.163 87.8477 209.024",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1387 224.829L75.4036 217.907C75.4036 217.907 86.5527 195.987 93.0002 196.633",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.999 165.818C137.373 167.733 135.228 168.24 128.529 166.337C125.836 165.575 116.079 170.121 114.744 167.64C113.603 165.402 119.309 162.287 125.825 158.803C129.499 156.83 130.686 154.315 132.363 151.154",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.408 195.536C129.93 197.613 138.135 191.66 139.756 190.426C149.82 182.788 154.591 174.493 158.836 162.287",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.41 166.256C122.389 172.348 112.073 178.335 107.509 183.838C107.318 184.068 107.192 184.345 107.143 184.641C107.095 184.937 107.126 185.24 107.233 185.52C107.341 185.799 107.52 186.044 107.753 186.23C107.986 186.415 108.265 186.533 108.559 186.573C110.536 186.629 112.486 186.091 114.162 185.027C118.939 182.345 123.482 179.257 127.741 175.797C124.831 179.177 121.066 181.45 113.249 188.165C111.503 189.665 113.534 191.176 115.44 190.853C119.571 190.126 127.285 184.761 131.416 181.519C127.319 185.823 118.281 190.507 118.692 192.953C119.331 197.152 131.587 190.114 136.152 185.765",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.448 231H206.229C205.57 231.005 204.917 230.872 204.315 230.61C203.713 230.348 203.175 229.962 202.737 229.479C202.3 228.996 201.973 228.427 201.779 227.81C201.585 227.193 201.528 226.543 201.612 225.903L220.082 166.003C220.226 164.907 220.775 163.9 221.626 163.173C222.477 162.446 223.57 162.05 224.699 162.059H228.994C230.133 162.052 231.236 162.458 232.088 163.198C232.941 163.939 233.483 164.962 233.611 166.071L251.042 225.914C251.124 226.552 251.067 227.199 250.873 227.813C250.68 228.427 250.355 228.993 249.92 229.474C249.485 229.955 248.951 230.34 248.352 230.604C247.753 230.867 247.104 231.002 246.448 231Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.625 160.375L263.024 151.13",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.865 178.446C219.91 180.933 234.293 181.17 237.56 178.028",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.135 191.127C218.754 195.648 239.267 193.783 241.541 191.127",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.275 203.661C214.76 209.312 244.185 206.43 246.113 203.661",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.154 217.246C209.219 221.077 242.557 221.348 250.846 216.579",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.823 167.71C225.081 168.142 228.382 168.169 231.647 167.789C231.992 167.746 232.321 167.623 232.608 167.431C232.895 167.239 233.131 166.982 233.296 166.683C233.462 166.384 233.553 166.051 233.561 165.71C233.569 165.37 233.495 165.033 233.344 164.726L230.723 159.415C230.519 159.02 230.207 158.689 229.822 158.458C229.437 158.226 228.994 158.104 228.542 158.104H225.079C224.621 158.099 224.172 158.221 223.782 158.455C223.392 158.689 223.077 159.025 222.874 159.426L220.172 164.693C220.029 164.994 219.958 165.323 219.968 165.656C219.977 165.988 220.065 166.313 220.225 166.606C220.386 166.899 220.613 167.152 220.891 167.343C221.168 167.535 221.488 167.661 221.823 167.71V167.71Z",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.457 167.495C233.323 168.252 266.823 172.197 266.823 172.197",
    stroke: "#F2EAE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 67,
    fill: "white",
    transform: "translate(36 41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 86,
    fill: "white",
    transform: "translate(252 29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 71,
    fill: "white",
    transform: "translate(138 37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 81,
    fill: "white",
    transform: "translate(201 150)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMobile);
export default __webpack_public_path__ + "static/media/icons-mobile.e7f1cb2c645566863fcea4d5daf9648e.svg";
export { ForwardRef as ReactComponent };